import * as Icons from 'react-icons/fa'
import { ButtonProps } from './index.types'
import styles from './styles.module.css'

export default function Button({ label, style, icon, iconPosition, textPosition, link }: ButtonProps) {
  const IconComponent = icon && Icons[icon as keyof typeof Icons] ? Icons[icon as keyof typeof Icons] : null
  const buttonStyles = [{ background: 'linear-gradient(90deg, #EA3326 0%, #81171E 100%)' }, { background: 'linear-gradient(90deg, #81171E 0%, #000000 100%)' }]

  const handleClick = () => {
    if (link) {
      window.location.href = link
    } else {
      console.log('Button clicked, but no link provided!')
    }
  }

  return (
    <div className={styles.buttonContainer} style={buttonStyles[style - 1] || buttonStyles[0]} onClick={handleClick}>
      {iconPosition === 'left' && IconComponent && (
        <div className={styles.icon}>
          <IconComponent style={{ fontSize: '25px' }} />
        </div>
      )}
      <div className={`${styles.label} ${styles[textPosition]}`}>{label}</div>
      {iconPosition === 'right' && IconComponent && (
        <div className={styles.icon}>
          <IconComponent style={{ fontSize: '25px' }} />
        </div>
      )}
    </div>
  )
}
